import {
  DefaultPage,
} from './';

export default {
  path: '/scheduling',
  name: 'Home',
  childRoutes: [
    { path: 'default-page',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/home/route.js